<template>
<div class="chapter">
<div class="inner_page">
<section class="dedication" epub:type="dedication">
<blockquote class=" bq">
<p class="centred firstInSection">To Bruce and Tracy</p>
<p class="centred">for all the help, advice, and moral support,</p>
<p class="centred">particularly the input on matters military</p>
</blockquote>
</section>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// chapter1.vue?9cb14258